import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import useTheme from '../../utilities/hooks/theme';
import React from 'react';

interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
}
const TransactionHistoryTabBarMWeb = ({ onChangeTab, activeTab, routes = [] }: Props) => {
  const { AccountTheme: theme } = useTheme();
  return (
    <Tabs
      onChange={onChangeTab}
      value={activeTab}
      style={{
        minHeight: 0,
        padding: 0,
        marginTop: '15px',
        marginBottom: '5px'
      }}
      variant="scrollable"
      TabIndicatorProps={{
        style: {
          background: theme.transactionHistoryTabBarActive,
          // width: '70px',
          height: '5px',
          borderRadius: '4px'
        }
      }}>
      {routes.map((item: any, index: any) => {
        const { key, title } = item;
        const isActive = activeTab === index;
        return (
          <Tab
            key={key}
            style={{
              flex: 1,
              minHeight: 0,
              minWidth: '100px',
              padding: 0,
              fontSize: '1.15rem',
              fontWeight: isActive ? 600 : 'normal',

              borderBottom: `1px solid ${theme.transactionHistoryTabBarActive}`,
              //   borderLeftStyle: 'solid',
              //   borderLeftColor: theme.transactionHistoryTabBarBorder,
              //   borderLeftWidth: index === 0 ? '0px' : '3px',
              backgroundColor: 'transparent',
              fontFamily: 'Poppins',
              textTransform: 'none',
              height: '40px',
              color: isActive
                ? theme.transactionHistoryTabBarActiveText
                : theme.transactionHistoryTabBarDefaultText
            }}
            label={`${title}`}
            value={index}
          />
        );
      })}
    </Tabs>
  );
};
export default React.memo(TransactionHistoryTabBarMWeb);
